module.exports = __webpack_public_path__ + "static/media/distribution_schedule.6e0f48d7.svg";